import { cn } from '@/lib/cn'

/**
 * Placeholder block. Decorative by definition, so it is hidden from the
 * accessibility tree — the live region that owns the pending data announces it.
 */
export function Skeleton(p: { className?: string }) {
  return <div aria-hidden="true" className={cn('shimmer h-4 w-full rounded-sm bg-s2', p.className)} />
}
